<template>
  <div>
    <b-row>
      <b-col>
        <Grid
          class="grid"
          :pageable="false"
          :resizable="true"
          :reorderable="true"
          :sortable="false"
          :row-height="25"
          :data-items="serialNumbersList"
          :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
          @columnresize="handleColumnResize"
          @rowclick="onEdit"
          @columnreorder="handleColumnReorder"
        >
          <template v-slot:commands="{props}">
            <td>
              <b-button size="sm" variant="primary" @click="onEdit(props.dataItem)">
                <i class="fa fa-edit"></i>
              </b-button>
              <b-button size="sm" variant="danger" @click="onDelete(props.dataItem)">
                <i class="fa fa-trash"></i>
              </b-button>

              <grid-settings :gridId="gridId" :fields="fields" />
            </td>
         </template>
        </Grid>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';

import GridSettings from '@/shared/components/GridSettings';
import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import serialNumberFields from './fields';
import inventorySerialNumberService from './service';

export default {
  components: {
    GridSettings,
  },
  metaInfo: () => ({
    title: 'Serial Numbers',
  }),
  data() {
    return {
      prepareColumnsData,
      serialNumbersList: [],
      fields: serialNumberFields,
    };
  },
  name: 'SerialNumbers',
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    partId() {
      return this.$route.params.partId;
    },
    gridId() {
      return GRID_ID.INVENTORY_SERIAL_NUMBERS;
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
  },
  methods: {
    ...mapActions('account', ['saveGridSettings']),
    async getSerialNumbersData() {
      this.serialNumbersList = await inventorySerialNumberService.getAllForPart(this.partId);
    },
    onEdit(row) {
      // @todo: implement when API will be ready
      row;
    },
    onDelete(row) {
      // @todo: implement when API will be ready
      row;
    },
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: serialNumberFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: { columns: newColumns },
      });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: serialNumberFields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: { columns: newColumns },
      });
    },
  },
}
</script>

<style lang="scss">
.inventory--serial-numbers-tab {
  .serial-numbers-grid-header {
    margin-bottom: 5px;
  }
  .tools > * {
    margin: 0 0 0 3px;
  }
  table td {
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
